var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.faClock}})],1),_c('span',{staticClass:"ps-2"},[_vm._v(_vm._s(_vm.times))])])])}
var staticRenderFns = []

export { render, staticRenderFns }